import { ComplaintDocument } from '@/interfaces';
import {
	Document,
	Text,
	Page,
	StyleSheet,
	View,
	Font,
} from '@react-pdf/renderer';
import { format } from 'date-fns';
import parse from 'html-react-parser';
import React from 'react';

interface Props {
	documentInfo?: ComplaintDocument;
	caseName?: string;
	// state: string;
	// placeOfBusiness: string;
	// lawyers: Lawyer[];
	// entityType: string;
	// companyName: string;
}

Font.register({
	family: 'Poppins-SemiBold',
	src: '/fonts/Poppins-SemiBold.ttf',
});

const styles = StyleSheet.create({
	page: {
		padding: 30,
	},
	text: {
		color: '#000',
		fontSize: 12,
		fontWeight: 400,
		lineHeight: 1.5,
	},
	title: {
		color: '#000',
		fontSize: 16,
		textAlign: 'center',
		fontFamily: 'Poppins-SemiBold',
	},
	subTitle: {
		color: '#000',
		fontSize: 14,
		fontWeight: 600,
		fontFamily: 'Poppins-SemiBold',
	},
	space: {
		marginBottom: '15px',
	},
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		marginBottom: 10,
	},
});

export const PDFComplaint = ({
	documentInfo,
	caseName,
}: // companyName,
// entityType,
// state,
// placeOfBusiness,
// lawyers,
Props) => {
	// const lawyersInfo = lawyers.map((item) => item.username).join(', ');

	const plaintiffUsers = documentInfo?.users.map(
		(item) =>
			`Plaintiff ${item.first_name} ${item.last_name} is a resident of  ${
				item.state
			}. Plaintiff ${item.last_name} ${
				documentInfo?.eligibility_criteria
			} on ${format(item.purchased_date, 'MM/dd/yyyy')}.`
	);

	const brands = documentInfo?.multiple_company.map(
		(item) =>
			`Defendant ${item.company} is a ${item.defendant} ${item.entity_type} with this principal place of business in ${item.principal_place}`
	);
	return (
		<Document>
			<Page size={'A4'} style={styles.page}>
				{/* Title */}
				<View style={styles.space}>
					<Text style={styles.title}>{`${caseName}`}</Text>
				</View>
				<View style={styles.space}>
					<Text style={styles.subTitle}>Plaintiffs:</Text>
				</View>
				{/* Clients */}
				<View style={styles.space}>
					{plaintiffUsers?.map((item) => (
						<>
							<Text key={'plaintiff-' + item} style={styles.text}>
								{parse(item)}
							</Text>
							<Text>{'\n'}</Text>
						</>
					))}
				</View>
				<View style={styles.space}>
					<Text style={styles.subTitle}>Defendant/s:</Text>
				</View>
				<View style={styles.space}>
					{brands?.map((item, idx) => (
						<React.Fragment key={`company-${idx}`}>
							<Text style={styles.text}>{parse(item)}</Text>
							<Text>{'\n'}</Text>
						</React.Fragment>
					))}
				</View>
			</Page>
		</Document>
	);
};
